var _g, _ellipse, _path, _path2, _ellipse2, _path3, _ellipse3, _path4, _path5, _ellipse4, _path6, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path7, _g11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleTypeCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7822 21.949C28.3455 21.5215 31.2026 20.3177 32.2417 19.3996C33.4375 18.4413 31.0377 17.2746 30.7538 17.1008C30.47 16.927 16.4913 9.57396 14.0496 8.42896C11.608 7.28396 3.73079 9.37024 1.8108 10.3696C0.245785 11.1842 1.32098 11.8155 1.52251 11.9872C1.72403 12.159 13.35 19.0055 17.5379 21.1112C20.7094 22.7059 23.7134 22.7881 26.7822 21.949Z",
    fill: "#D1D5DB"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.85106,
    cy: 3.14104,
    rx: 1.85106,
    ry: 3.14104,
    transform: "matrix(-0.922932 0.384962 0.385343 0.922773 19.2671 12.9121)",
    fill: "#1A1E25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.54 13.6406L15.9554 14.3247L18.4247 20.1012L19.9799 19.4288L17.54 13.6406Z",
    fill: "#1A1E25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3616 18.0605C16.0296 19.66 17.336 20.6377 18.2795 20.2441C19.223 19.8506 19.4464 18.2349 18.7784 16.6354C18.1105 15.0358 16.7662 13.972 15.8227 14.3656C14.8792 14.7591 14.6937 16.461 15.3616 18.0605Z",
    fill: "#2A313C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.30184,
    cy: 2.26901,
    rx: 1.30184,
    ry: 2.26901,
    transform: "matrix(-0.918685 0.394991 0.372295 0.928114 17.4185 14.6572)",
    fill: "#D1D5DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6447 18.8396L17.3908 18.0353C17.5321 17.9631 17.6049 17.7735 17.5994 17.5408L18.082 17.3016C18.2519 18.0146 18.1043 18.6584 17.6925 18.8354C17.6615 18.8488 17.6297 18.8591 17.5972 18.8666L17.6447 18.8396ZM17.898 16.7685L17.4564 16.9873C17.3142 16.6995 17.0967 16.5076 16.9028 16.4886L16.645 15.6719C17.0777 15.6541 17.5896 16.0932 17.898 16.7685ZM16.7808 17.9464L17.0348 18.7513C16.8158 18.6231 16.6006 18.406 16.421 18.1247L16.7808 17.9464ZM16.1692 17.6252L16.6097 17.4069C16.5965 17.3694 16.585 17.3321 16.5752 17.295L16.1573 15.9705C15.9274 16.3347 15.9189 16.9797 16.1692 17.6252Z",
    fill: "#83888E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.49773,
    cy: 2.68277,
    rx: 1.49773,
    ry: 2.68277,
    transform: "matrix(-0.911753 0.41074 0.360626 0.93271 6.5542 6.91992)",
    fill: "#1A1E25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17334 7.54883L3.90674 8.13937L5.88048 13.1262L7.12357 12.5458L5.17334 7.54883Z",
    fill: "#1A1E25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43208 11.3651C3.966 12.746 5.0102 13.59 5.76438 13.2503C6.51856 12.9105 6.69712 11.5157 6.16321 10.1348C5.62929 8.75395 4.55481 7.83556 3.80063 8.17531C3.04645 8.51506 2.89816 9.98427 3.43208 11.3651Z",
    fill: "#2A313C"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.05401,
    cy: 1.93936,
    rx: 1.05401,
    ry: 1.93936,
    transform: "matrix(-0.906981 0.421172 0.348165 0.937433 5.07666 8.42676)",
    fill: "#D1D5DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25792 12.0372L5.05494 11.3425C5.14994 11.2897 5.2061 11.165 5.21865 11.0068L5.62323 10.7902C5.73194 11.3732 5.61031 11.8878 5.29559 12.034C5.27075 12.0455 5.24532 12.0545 5.21938 12.0609L5.25792 12.0372ZM5.4598 10.2496L5.107 10.4384C4.99347 10.1901 4.81987 10.0244 4.66491 10.0076L4.45898 9.30284C4.80469 9.28806 5.2135 9.66698 5.4598 10.2496ZM4.49988 11.3915L4.63751 11.8625C4.52547 11.7659 4.41745 11.6389 4.32048 11.4875L4.49988 11.3915ZM4.07799 10.9892L4.34117 10.8483L4.00491 9.69747C3.88652 10.0223 3.90434 10.5056 4.07799 10.9892Z",
    fill: "#83888E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7923 7.89883C24.8601 7.94232 24.9203 7.97261 24.9732 7.98816C25.5507 8.1579 30.3539 10.9421 31.3887 12.0383C32.3956 13.1051 32.3225 13.7257 32.2885 14.0138C32.2836 14.0554 32.2795 14.09 32.2796 14.1181C32.2801 14.2581 32.2719 14.5397 32.2614 14.8978C32.2553 15.1088 32.2483 15.3464 32.2419 15.5974L32.2202 16.4499C32.2166 16.5135 32.2152 16.5785 32.2138 16.6448C32.2079 16.9266 32.2014 17.2329 32.0195 17.5641C31.7952 17.9724 30.7246 19.4632 25.677 20.9037C23.9677 21.3915 22.0132 20.7537 20.7685 20.2032C20.3303 20.0281 19.982 19.8597 19.7662 19.7494C19.7214 19.7265 19.683 19.6952 19.6519 19.6579C19.6431 19.6474 19.6328 19.6382 19.6208 19.6316C19.5792 19.6087 19.5524 19.5659 19.5494 19.5185C19.523 19.1043 19.4413 18.5425 19.3178 17.9768C19.1645 17.3165 18.9548 16.6572 18.7168 16.2271C18.1666 15.233 16.9733 13.9939 16.0023 14.3006C14.9003 14.6486 14.9444 16.2155 14.9558 16.5897C14.9592 16.6997 14.9701 16.7733 14.9809 16.846C14.9836 16.8642 14.9847 16.8819 14.9843 16.8991C14.9833 16.9413 14.9851 16.9841 14.9931 17.0256C14.9945 17.0326 14.9957 17.04 14.9969 17.048C15.0163 17.1836 14.86 17.2657 14.7398 17.2C14.7098 17.1835 14.6758 17.1768 14.6418 17.173C14.5986 17.1682 14.5549 17.155 14.513 17.1322L6.52208 12.8023C6.41851 12.7462 6.34536 12.6451 6.33861 12.5275C6.32945 12.3678 6.33445 12.1891 6.33991 11.994L6.33992 11.9938C6.35847 11.3313 6.38233 10.4798 5.87509 9.54123C5.41145 8.68333 4.71886 8.10572 4.07206 8.29008C3.42525 8.47445 3.23319 9.1584 3.18844 9.5409C3.14449 9.91652 3.15611 10.2626 3.16285 10.4633L3.16286 10.4634C3.16556 10.5441 3.16748 10.6013 3.16467 10.6274C3.15488 10.7184 2.25112 9.90324 2.19941 9.60003C2.04204 8.67718 2.02628 7.81634 2.14489 6.88666C2.16249 6.74864 2.21864 6.41986 2.26396 6.24783C2.2783 6.19339 2.28722 6.13731 2.28664 6.08101C2.28341 5.76359 2.34922 5.33138 2.4375 5.14435C2.44579 5.12677 2.45391 5.10826 2.46244 5.08882L2.4625 5.08867C2.5623 4.86113 2.71816 4.50578 3.86165 4.03072C5.48535 3.35616 9.89762 1.87467 10.0677 1.84173C10.4696 1.76391 10.9805 1.81462 11.3942 1.85567C11.6369 1.87976 11.8461 1.90052 11.9801 1.89005C13.915 1.73877 16.1452 2.06049 19.0588 3.61716C19.4511 3.79464 19.8384 3.99572 20.2126 4.22366C21.1489 4.79408 21.9339 5.39462 22.5848 5.94481C23.3376 6.54916 23.9166 7.08985 24.3329 7.47851C24.5179 7.65123 24.6707 7.79392 24.7923 7.89883Z",
    fill: "url(#paint0_linear_11445_9361)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddi_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9561 11.0223C15.9182 10.5634 15.3537 9.15139 13.8501 7.46114C13.7604 7.36027 13.7985 7.19931 13.9251 7.15234L20.469 4.72479C20.4975 4.71421 20.5278 4.71089 20.5569 4.71982C20.73 4.77297 21.4373 5.07109 23.1896 6.68617C24.1231 7.5465 24.3086 7.76913 24.7935 8.11271C24.8701 8.16706 24.8537 8.28204 24.5611 8.51007C23.6283 9.23701 18.5271 11.717 16.9561 11.0223Z",
    fill: "url(#paint1_radial_11445_9361)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52746 5.19863C8.12738 4.72055 7.76425 4.70886 6.79132 4.62953C6.12185 4.57494 5.05487 4.64678 4.93108 4.94449C4.80729 5.2422 6.07195 6.21901 6.59789 6.5265C6.85494 6.67677 15.7346 11.3934 15.4621 10.8556C15.1264 10.193 13.5523 8.28471 13.0178 7.50823C12.1268 6.21362 10.9275 5.67672 9.52746 5.19863Z",
    fill: "url(#paint2_radial_11445_9361)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35116 4.23284L12.3335 1.98047C12.3335 1.98047 12.1996 2.02371 11.4733 1.9947C11.2199 1.98457 5.01052 4.34534 4.96462 4.38352L6.35116 4.23284Z",
    fill: "url(#paint3_linear_11445_9361)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5944 14.3296C17.3472 13.2193 16.1032 11.8654 14.764 10.6227C18.8129 11.9306 27.2845 14.7829 27.1463 14.9511C26.9736 15.1614 26.3539 15.4003 24.3126 15.4856C22.3029 15.5697 19.8517 14.4568 19.5944 14.3296Z",
    fill: "url(#paint4_linear_11445_9361)",
    fillOpacity: 0.21
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5834 11.0043C11.5847 10.952 11.5561 10.9036 11.5096 10.8796L10.8539 10.5412C10.764 10.4948 10.6564 10.5585 10.6538 10.6596C10.6525 10.7122 10.6814 10.7609 10.7282 10.785L11.3844 11.1223C11.4739 11.1683 11.5808 11.105 11.5834 11.0043Z",
    fill: "#4E545D"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_di_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.28166 8.98187C7.28299 8.92958 7.25431 8.88114 7.20782 8.85715L6.55216 8.51879C6.46222 8.47237 6.35464 8.53601 6.35206 8.63717C6.35072 8.68976 6.37961 8.73846 6.4264 8.76252L7.0826 9.09984C7.17215 9.14587 7.27909 9.08249 7.28166 8.98187Z",
    fill: "#4E545D"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.17,
    filter: "url(#filter8_f_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5259 13.3555C29.0854 14.4327 25.9033 15.9443 24.4944 16.1515",
    stroke: "url(#paint5_linear_11445_9361)",
    strokeWidth: 6.25786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ddii_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5931 13.7887C31.8696 13.4359 31.8092 13.1452 31.78 12.6985C31.778 12.669 31.7719 12.6393 31.7646 12.6106C31.6864 12.3056 32.1597 13.0488 32.1993 13.5596C32.2127 13.7329 32.1993 13.8201 32.179 13.9792C32.1697 14.052 32.0076 14.4937 32.0275 14.5904C32.0475 14.6872 31.9814 15.3488 31.9822 15.4491C31.9831 15.5494 31.5441 16.2842 30.4225 16.9753C29.4907 17.5494 28.1647 17.9082 28.0293 17.9241C27.8939 17.94 27.7732 17.4858 27.6759 17.4584C27.4212 17.3868 26.6571 17.6447 26.3726 17.7083C26.0407 17.7826 25.2664 17.9536 24.4281 17.8247C23.3913 17.6653 23.2351 17.5435 22.292 17.0006C21.8314 16.7355 21.4751 16.297 21.257 15.9339C21.1196 15.7052 21.3204 15.5054 21.5715 15.5959C22.2967 15.8572 23.4852 16.2677 24.8106 16.437C27.1003 16.7295 28.9413 15.6886 29.205 15.5389C30.3137 14.9098 30.8935 14.6815 31.5931 13.7887Z",
    fill: "#1A1E25"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11445_9361",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 12,
    height: 5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5938 13.7844C31.6129 13.76 31.6305 13.7352 31.6467 13.7101C31.843 13.4061 32.2652 13.2195 32.3111 13.5784C32.3246 13.7517 32.3176 13.8613 32.2974 14.0204C32.2881 14.0932 32.0088 14.4891 32.0288 14.5858C32.0487 14.6826 31.9831 15.3442 31.984 15.4445C31.9849 15.5448 31.5464 16.2799 30.4252 16.9717C29.4938 17.5464 28.168 17.906 28.0326 17.922C27.8973 17.938 27.7762 17.4839 27.6789 17.4566C27.4242 17.3851 26.6602 17.6435 26.3759 17.7073C26.044 17.7818 25.2697 17.9533 24.4314 17.825C23.3945 17.6662 23.2382 17.5445 22.2948 17.0022C21.834 16.7374 21.4774 16.2991 21.2591 15.9362C21.1215 15.7075 21.3223 15.5076 21.5734 15.5979C22.2988 15.8589 23.4875 16.2686 24.813 16.437C27.1029 16.728 28.9432 15.6859 29.2068 15.5361C30.3151 14.9063 30.8947 14.6776 31.5938 13.7844Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11445_9361)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7283 15.9437L25.7285 15.9441L25.7284 15.944L25.7283 15.9438L25.7283 15.9437ZM25.7533 16.0261C25.7564 16.0391 25.7595 16.0533 25.7622 16.0686C25.7767 16.1493 25.7822 16.2533 25.7533 16.3578C25.7252 16.4594 25.6631 16.5676 25.5314 16.6607C25.3973 16.7555 25.1839 16.8396 24.8468 16.876C24.6499 16.8973 24.3752 16.8896 24.0939 16.829C23.8121 16.7683 23.5336 16.6568 23.3202 16.4783C23.2076 16.3841 23.0647 16.1932 22.9438 16.0126C22.9201 15.9771 22.8976 15.9426 22.8768 15.9102L25.7533 16.0261Z",
    stroke: "white",
    strokeWidth: 0.28216
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_11445_9361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7649 12.9923C31.7737 13.0155 31.7822 13.0405 31.7899 13.067C31.8377 13.2311 31.8548 13.4461 31.7427 13.6713C31.7137 13.7297 31.6783 13.7579 31.6543 13.7669C31.6382 13.7729 31.6137 13.7765 31.5734 13.7446C31.5142 13.6975 31.4378 13.6813 31.3812 13.6742C31.352 13.6705 31.3219 13.6686 31.2922 13.668L31.7649 12.9923Z",
    stroke: "white",
    strokeWidth: 0.28216
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11445_9361",
    x: 0.14892,
    y: 7.26855,
    width: 33.2505,
    height: 16.0332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.413089,
    result: "effect1_foregroundBlur_11445_9361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_11445_9361",
    x: 2.06689,
    y: -0.0802844,
    width: 31.6486,
    height: 21.1574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.4108,
    dy: -1.88107
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6432
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.235133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.470266
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11445_9361",
    result: "effect2_innerShadow_11445_9361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddi_11445_9361",
    x: 13.4215,
    y: 4.4304,
    width: 11.6006,
    height: 6.99761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.189632,
    dy: 0.094816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.094816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.094816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.094816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_11445_9361",
    result: "effect2_dropShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_11445_9361",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.094816,
    dy: 0.284448
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.142224
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_11445_9361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_11445_9361",
    x: 4.5431,
    y: 4.6123,
    width: 11.0232,
    height: 6.6654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.098052
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.049026
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11445_9361",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.379264,
    dy: 0.47408
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.189632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_11445_9361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_11445_9361",
    x: 4.58558,
    y: 1.98047,
    width: 7.84597,
    height: 2.78258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.098052
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.049026
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11445_9361",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.379264,
    dy: 0.47408
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.189632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_11445_9361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_11445_9361",
    x: 12.1093,
    y: 7.9682,
    width: 17.6935,
    height: 10.1769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.32742,
    result: "effect1_foregroundBlur_11445_9361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_11445_9361",
    x: 10.6068,
    y: 10.4313,
    width: 1.02374,
    height: 0.941491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.0470266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0235133
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11445_9361",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117567
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_11445_9361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_di_11445_9361",
    x: 6.30502,
    y: 8.40888,
    width: 1.02374,
    height: 0.941491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.0470266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0235133
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11445_9361",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117567
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_11445_9361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_11445_9361",
    x: 20.4171,
    y: 9.2784,
    width: 14.1859,
    height: 10.951,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.47408,
    result: "effect1_foregroundBlur_11445_9361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ddii_11445_9361",
    x: 21.0944,
    y: 12.362,
    width: 11.2282,
    height: 6.37623,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.088509
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.059006
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.059006
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.059006
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_11445_9361",
    result: "effect2_dropShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_11445_9361",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.813466
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82901
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.0886441
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0886441
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_11445_9361",
    result: "effect4_innerShadow_11445_9361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_11445_9361",
    x: 22.5959,
    y: 15.7588,
    width: 3.53005,
    height: 1.50222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0940533,
    dy: 0.116832
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0584159
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11445_9361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_11445_9361",
    x: 30.9826,
    y: 12.7197,
    width: 1.19607,
    height: 1.42605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0940533,
    dy: 0.116832
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0584159
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11445_9361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11445_9361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11445_9361",
    x1: 18.8841,
    y1: 20.0525,
    x2: 33.1635,
    y2: 3.45861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0564FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FA6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11445_9361",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8202 4.78473) rotate(149.926) scale(12.8802 6.67836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592618,
    stopColor: "#1A1E25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_11445_9361",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6699 3.74971) rotate(137.069) scale(12.2291 7.02559)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592618,
    stopColor: "#1A1E25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11445_9361",
    x1: 4.20075,
    y1: 9.35213,
    x2: 8.55849,
    y2: 3.28565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498386,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11445_9361",
    x1: 20.4696,
    y1: 15.6689,
    x2: 21.5194,
    y2: 12.8259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11445_9361",
    x1: 27.5648,
    y1: 16.1978,
    x2: 26.9381,
    y2: 14.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899322,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleTypeCar);
export default __webpack_public_path__ + "static/media/vehicleTypeCar.885ef24d38a62d6cb632ec23182bb8ba.svg";
export { ForwardRef as ReactComponent };